import { render } from "./AddModeratorView.vue?vue&type=template&id=3a3dce70&scoped=true&ts=true"
import script from "./AddModeratorView.vue?vue&type=script&lang=ts"
export * from "./AddModeratorView.vue?vue&type=script&lang=ts"

import "./AddModeratorView.vue?vue&type=style&index=0&id=3a3dce70&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3dce70"]])

export default __exports__